// ABOUTME: Renders the default read-only value for metadata-driven view fields.
// ABOUTME: Normalizes list option values before formatting them for display.
import React from "react";
import ItemView from "./ItemView";
import Icon from "@material-ui/core/Icon";
import { transformDBData } from "functions/util";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import _ from "lodash";
import { IFieldProps } from ".";
import { resolveAutocompleteOptionValue } from "customHooks/useCompleoReactHookForm/Inputs/util/AutoCompleteUtil";

const useStyles = makeStyles((theme: Theme) => createStyles({}));

const FieldDefault = (props: IFieldProps) => {
    const classes = useStyles();
    const { fieldData, fieldName, fieldDef, t, language, inline, listas } =
        props;
    const fieldValue = resolveFieldDefaultViewValue({
        fieldName,
        value: _.get(fieldData, fieldName),
        listas
    });

    return (
        <ItemView
            label={
                fieldDef.cardIcon ? (
                    <Icon color="action" fontSize="small">
                        {fieldDef.cardIcon}
                    </Icon>
                ) : (
                    `${t(fieldName)}: `
                )
            }
            fieldDef={fieldDef}
            removeColonAfterLabel={true}
            inline={inline}
        >
            {fieldDef?.viewElementType === "url" &&
            _.get(fieldData, fieldName) ? (
                <a
                    href={_.get(fieldData, fieldName)}
                    target="_blank"
                    rel="noreferrer"
                >
                    {transformDBData({
                        value: fieldValue,
                        t,
                        language,
                        replaceOption: "-",
                        customDateFormat: fieldDef?.viewOptionCustomDateFormat
                    })}
                </a>
            ) : (
                transformDBData({
                    value: fieldValue,
                    t,
                    language,
                    replaceOption: "-",
                    customDateFormat: getDateFormat(fieldDef)
                })
            )}
        </ItemView>
    );
};

export const resolveFieldDefaultViewValue = ({
    fieldName,
    value,
    listas = {}
}: {
    fieldName: string;
    value: any;
    listas?: Compleo.IObject;
}) => {
    return resolveAutocompleteOptionValue(
        value,
        resolveFieldDefaultList({
            fieldName,
            listas
        })
    );
};

export const resolveFieldDefaultList = ({
    fieldName,
    listas = {}
}: {
    fieldName: string;
    listas?: Compleo.IObject;
}) => {
    const fieldList = listas[fieldName];

    if (fieldList) {
        return fieldList;
    }

    const fieldNameParts = fieldName.split(".");

    if (fieldNameParts.length < 2) {
        return [];
    }

    return (
        listas[
            `COMPLEXFIELD:${fieldNameParts[0]}_${
                fieldNameParts[fieldNameParts.length - 1]
            }`
        ] || []
    );
};

const getDateFormat = (fieldDef: Compleo.IObject) => {
    if (!fieldDef) return undefined;
    if (fieldDef.onlyMonthYear) {
        return "onlyMonthYear";
    }
    if (fieldDef.elementConfig?.onlyTime === true) {
        return "time";
    }
    if (fieldDef.viewOptionCustomDateFormat) {
        return fieldDef.viewOptionCustomDateFormat;
    }

    return undefined;
};

export default FieldDefault;
